<template>
  <div class="p-d-flex p-flex-column w-100 p-text-truncate">
    <div class="p-d-flex p-ai-center p-text-truncate">
      <LGAvatar
        :icone="icone"
        :avatar="foto"
        :alt="nome"
        :tamanho="tamanhoIcone"
      />

      <div
        class="p-ml-2 p-d-flex p-flex-column p-jc-center p-text-truncate"
        style="flex: 1"
      >
        <div class="p-d-flex p-jc-between p-ai-center">
          <h4
            :class="[
              'p-text-truncate p-px-0 p-py-1 p-text-bold',
              'lg-aa-titulo lg-aa-texto--primario-super ',
              tituloClass,
            ]"
            style="flex: 1"
            tabindex="0"
          >
            {{ nome }}
          </h4>
        </div>
        <p
          class="p-mb-0 p-text-truncate p-text-normal lg-aa-texto--primario-super lg-aa-font-size--12"
          tabindex="0"
        >
          {{ cargo }}
        </p>
      </div>
      <div
        v-if="$slots.default"
        class="text-md-right p-mb-0 p-text-truncate lg-aa-texto--primario-super"
      >
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import LGAvatar from 'lg-vue-components/avatar';

export default {
  name: 'LGCardColaborador',
  components: {
    LGAvatar,
  },
  props: {
    foto: {
      type: String,
      default: null,
    },
    icone: {
      type: String,
      default: null,
    },
    nome: {
      type: String,
      default: '',
    },
    cargo: {
      type: String,
      default: '',
    },
    tamanhoIcone: {
      type: Number,
      default: 40,
    },
    tituloClass: {
      type: String,
      default: 'lg-aa-font-size--14',
    },
  },
};
</script>
